export default __webpack_public_path__ + "static/ELE-Barcelona-logo-d0f689b2d908bbd8c18ae3b23b63fa58.svg";